"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$gtm = void 0;
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _gtm = _interopRequireDefault(require("../transformers/gtm.transformer"));
var _constants = _interopRequireDefault(require("../constants"));
var _cookie = require("./cookie.service");
/**
 * gtm service
 */
var $gtm = {
  /**
   * push dataLayer object for gtm
   *
   * @param {Object} data object
   *
   */
  pushDataLayer: function pushDataLayer(data) {
    if ((0, _isArray2["default"])(window.dataLayer)) {
      window.dataLayer.push(data);
    }
  },
  /**
   * send google analytics event
   * @param cat
   * @param action
   * @param label
   * @param value
   * @param fieldsObject
   */
  sendGaEvent: function sendGaEvent(cat) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var fieldsObject = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    if (!(0, _isUndefined2["default"])(window._gat)) {
      if ((0, _isUndefined2["default"])(cat)) return;
      window._gat('send', 'event', cat, action, label, value, fieldsObject);
      window._gat('base.send', 'event', cat, action, label, value, fieldsObject);
    }
  },
  /**
   * send global information like locale, currency to GTM
   * @param tracker
   */
  triggerGlobals: function triggerGlobals(tracker) {
    this.pushDataLayer({
      event: 'globals',
      env: window.config.env,
      language: window.config.language,
      currency: window.config.currency,
      country: window.config.country,
      clientId: tracker ? tracker.get('clientId') : null,
      login: null
    });
  },
  /**
   * send global information to google analytics
   */
  triggerGAGlobalEvent: function triggerGAGlobalEvent() {
    var _this = this;
    if (window.ga) {
      window.ga(this.triggerGlobals);
    } else {
      var retry = 5;
      var interval = setInterval(function () {
        if (retry === 0) {
          clearInterval(interval);
        }
        if (window.ga) {
          window.ga(_this.triggerGlobals);
          clearInterval(interval);
        } else {
          retry--;
        }
      }, 1500);
    }
  },
  /**
   * send flight search data to GTM
   * @param data
   */
  sendFlightSearchEvent: function sendFlightSearchEvent(data) {
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.FLIGHTS.FLIGHT_SEARCH,
      flightSearch: data,
      page: 'flight.home'
    });
  },
  /**
   * send flight modify search data to GTM
   * @param data
   */
  sendFlightSearchModifyEvent: function sendFlightSearchModifyEvent(data) {
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.FLIGHTS.FLIGHT_MODIFY_SEARCH,
      flightSearch: data,
      page: 'flight.results'
    });
  },
  /**
   * send flight search detail data to GTM
   * @param data
   */
  sendFlightSearchDetailEvent: function sendFlightSearchDetailEvent(data) {
    var searchInfo = null;
    if (data.searchInfo) {
      searchInfo = data.searchInfo;
    } else if (data.flight) {
      searchInfo = _gtm["default"].flightProductToSearchInfo(data.flight, data.airportsMap);
    }
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.FLIGHTS.FLIGHT_SEARCH_DETAIL,
      searchInfo: searchInfo,
      airportsMap: data.airportsMap,
      page: data.page
    });
  },
  /**
   * send flight search result data to GTM
   * @param data
   */
  sendFlightSearchResultEvent: function sendFlightSearchResultEvent(data) {
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.FLIGHTS.FLIGHT_RESULTS,
      numberOfSearchResults: data.totalCount,
      ecommerce: {
        currencyCode: window.config.baseCurrency,
        // prices are in baseCurrency, conversion is only UI
        impressions: (0, _map2["default"])(data.fares.slice(0, 10), function (fare, index) {
          return _gtm["default"].itineraryToGaProduct(fare, index + 1, 'Flight Search Results');
        })
      }
    });
  },
  /**
   * send selected flight data to GTM
   * @param data
   */
  sendFlightSelectEvent: function sendFlightSelectEvent(data) {
    var _this2 = this;
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.FLIGHTS.FLIGHT_SELECT,
      ecommerce: {
        currencyCode: window.config.baseCurrency,
        // prices are in baseCurrency, conversion is only UI
        add: {
          products: [_gtm["default"].itineraryToGaProduct(data.flight, data.index + 1, 'Flight Search Results')]
        }
      }
    });
    if (window._gat) {
      var impression = _gtm["default"].itineraryToGaProduct(data.flight, data.index + 1, 'Flight Search Results');
      setTimeout(function () {
        window._gat('ec:addProduct', impression);
        window._gat('ec:setAction', 'add', {
          list: 'Flight Search Results'
        });
        window._gat('base.ec:addProduct', impression);
        window._gat('base.ec:setAction', 'add', {
          list: 'Flight Search Results'
        });
        _this2.sendGaEvent('Ecommerce', 'Add Product', '', 0, {
          nonInteraction: 1
        });
      }, 1000);
    }
  },
  /**
   * send flight traveller and checkout data to GTM
   * @param data
   */
  sendFlightCheckoutEvent: function sendFlightCheckoutEvent(data) {
    var _this3 = this;
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.FLIGHTS.FLIGHT_DETAILS,
      searchInfo: _gtm["default"].flightProductToSearchInfo(data.flight),
      page: 'flight.details'
    });
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.FLIGHTS.FLIGHT_DETAILS,
      section: data.section,
      ecommerce: {
        currencyCode: window.config.baseCurrency,
        details: {
          products: [_gtm["default"].flightProductToGaProduct(data.flight)]
        }
      }
    });
    if (window._gat) {
      var product = _gtm["default"].flightProductToGaProduct(data.flight);
      window._gat('ec:addProduct', product);
      window._gat('ec:setAction', 'checkout', {
        step: data.step
      });
      window._gat('base.ec:addProduct', product);
      window._gat('base.ec:setAction', 'checkout', {
        step: data.step
      });
      setTimeout(function () {
        _this3.sendGaEvent('Ecommerce', data.category, '', 0, {
          nonInteraction: 1
        });
      }, 700);
    }
  },
  /**
   * send flight booking confirmation data to GTM
   * @param orderDetail
   */
  sendFlightBookingConfirmationEvent: function sendFlightBookingConfirmationEvent(orderDetail) {
    var product = _gtm["default"].flightProductToGaProduct((0, _get2["default"])(orderDetail, 'flights.0', null));
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.FLIGHTS.FLIGHT_BOOKING,
      status: orderDetail.status,
      ecommerce: {
        currencyCode: orderDetail.currency,
        purchase: {
          actionField: {
            id: (0, _get2["default"])(orderDetail, 'orderNumber', null),
            // booking id,
            revenue: (0, _get2["default"])(orderDetail, 'totals.total', 0),
            coupon: (0, _get2["default"])(orderDetail, 'coupon', null),
            orderTotalUsd: (0, _get2["default"])(orderDetail, 'orderTotalUsd', null)
          },
          products: [(0, _assign2["default"])({}, (0, _omit2["default"])(product, 'position', 'list'), {
            price: (0, _get2["default"])(orderDetail, 'totals.total', 0)
          })]
        }
      },
      paymentType: 'pay-now',
      checkoutType: 'Flight'
    });
  },
  /**
   * send hotel search data to GTM
   * @param data
   */
  sendHotelSearchEvent: function sendHotelSearchEvent(data) {
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.HOTELS.HOTEL_SEARCH,
      hotelSearch: data,
      page: 'hotel.home'
    });
  },
  /**
   * send hotel search select data to GTM
   * @param data
   */
  sendHotelSearchSelectEvent: function sendHotelSearchSelectEvent(data) {
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.HOTELS.HOTEL_SEARCH_SELECT,
      selectedHotel: data.selectedHotel,
      page: data.page
    });
  },
  /**
   * send hotel result data to GTM
   * @param data
   */
  sendHotelResultsEvent: function sendHotelResultsEvent(data) {
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.HOTELS.HOTEL_RESULTS,
      numberOfSearchResults: data.totalCount,
      ecommerce: {
        currencyCode: window.config.baseCurrency,
        // prices are in baseCurrency, conversion is only UI
        impressions: (0, _map2["default"])(data.hotels.slice(0, 10), function (hotel, index) {
          return _gtm["default"].hotelsToGaProduct(hotel, index + 1, 'Hotel Search Results');
        })
      }
    });
  },
  /**
   * send hotel select data to GTM
   * @param data
   */
  sendHotelSelectEvent: function sendHotelSelectEvent(data) {
    var _this4 = this;
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.HOTELS.HOTEL_SELECT,
      ecommerce: {
        currencyCode: window.config.baseCurrency,
        // prices are in baseCurrency, conversion is only UI
        add: {
          products: [_gtm["default"].hotelsToGaProduct(data.hotel, data.index + 1, 'Hotel Search Results')]
        }
      }
    });
    if (window._gat) {
      var impression = _gtm["default"].hotelsToGaProduct(data.hotel, data.index + 1, 'Hotel Search Results');
      setTimeout(function () {
        window._gat('ec:addProduct', impression);
        window._gat('ec:setAction', 'add', {
          list: 'Hotel Search Results'
        });
        window._gat('base.ec:addProduct', impression);
        window._gat('base.ec:setAction', 'add', {
          list: 'Hotel Search Results'
        });
        _this4.sendGaEvent('Ecommerce', 'Add Product', '', 0, {
          nonInteraction: 1
        });
      }, 1000);
    }
  },
  /**
   * send hotel booking data to GTM
   * @param data
   */
  sendHotelBookingEvent: function sendHotelBookingEvent(data) {
    this.pushDataLayer({
      event: _constants["default"].APP_EVENTS.HOTELS.HOTEL_BOOKING,
      status: data.status,
      ecommerce: {
        currencyCode: window.config.baseCurrency,
        purchase: {
          actionField: {
            id: (0, _get2["default"])(data, 'booking.id', null),
            // booking id,
            revenue: (0, _get2["default"])(data, 'booking.revenue', 0),
            coupon: (0, _get2["default"])(data, 'booking.coupon', null),
            orderTotalUsd: (0, _get2["default"])(data, 'orderTotalUsd', null)
          },
          products: [(0, _assign2["default"])({}, (0, _omit2["default"])(data.product, 'position', 'list'), {
            price: (0, _get2["default"])(data, 'booking.revenue', 0)
          })]
        }
      },
      checkoutType: 'Hotel'
    });
  },
  /**
   * send hotel booking confirmation data to GTM
   * @param orderDetail
   */
  sendHotelBookingConfirmationEvent: function sendHotelBookingConfirmationEvent(orderDetail) {
    var orderNumber = orderDetail.orderNumber;
    if (window._gat) {
      var product = _gtm["default"].getHotelGaProduct((0, _get2["default"])(orderDetail, 'hotels.0.options', null));
      var order = {
        id: orderNumber,
        revenue: orderDetail.totals.total
      };

      // set cookie
      _cookie.$cookie.set(orderNumber, 'ga*', 60);
      window._gat('set', '&cu', orderDetail.currency);
      window._gat('ec:addProduct', product);
      window._gat('ec:setAction', 'purchase', order);
      window._gat('set', '&cu', orderDetail.currency);
      window._gat('base.ec:addProduct', product);
      window._gat('base.ec:setAction', 'purchase', order);
      this.sendGaEvent('Ecommerce', 'Purchase', '', 0, {
        nonInteraction: 1
      });
    }
  }
};
exports.$gtm = $gtm;